/**
 * Seed content used when a family is first created.
 *
 * The eight prep items are the ones named in the design conversation:
 * リュック, お弁当, 水筒, 帽子, おむつ, ハンカチ・タオル, 上履き, 着替え.
 * They are seeded as ordinary editable documents, not hardcoded — the Prep
 * screen can add to and archive them.
 */

export type PrepSeed = {
  icon: string;
  label: string;
  labelEn: string;
  note: string | null;
};

export const DEFAULT_PREP_ITEMS: PrepSeed[] = [
  { icon: 'Backpack', label: 'リュック', labelEn: 'Backpack', note: null },
  { icon: 'Utensils', label: 'お弁当', labelEn: 'Obentou', note: null },
  { icon: 'Droplets', label: '水筒', labelEn: 'Water bottle', note: '麦茶' },
  { icon: 'HardHat', label: '帽子', labelEn: 'Hat', note: '玄関' },
  { icon: 'Baby', label: 'おむつ 3枚', labelEn: 'Spare diapers', note: 'バッグ内' },
  { icon: 'Shirt', label: 'ハンカチ・タオル', labelEn: 'Handkerchief & towel', note: null },
  { icon: 'Footprints', label: '上履き', labelEn: 'Indoor shoes', note: null },
  { icon: 'Shirt', label: '着替え', labelEn: 'Change of clothes', note: null },
];

/**
 * Milestones a parent can tick off. The design keeps this section low-key and
 * toggleable — one parent already tracks these by hand and it should not take
 * over the Growth screen.
 */
export const MILESTONE_SUGGESTIONS: { icon: string; jp: string; en: string }[] = [
  { icon: 'Smile', jp: 'はじめての笑顔', en: 'First smile' },
  { icon: 'Baby', jp: '首がすわった', en: 'Holds head up' },
  { icon: 'RefreshCw', jp: '寝返り', en: 'Rolled over' },
  { icon: 'ArrowUp', jp: 'おすわり', en: 'Sits up' },
  { icon: 'Utensils', jp: 'はじめての離乳食', en: 'First solid food' },
  { icon: 'Sparkles', jp: 'はじめての歯', en: 'First tooth' },
  { icon: 'Footprints', jp: 'はいはい', en: 'Crawls' },
  { icon: 'MessageCircle', jp: 'はじめてのことば', en: 'First word' },
  { icon: 'PersonStanding', jp: 'つかまり立ち', en: 'Pulls to stand' },
  { icon: 'Footprints', jp: 'はじめてのあんよ', en: 'First steps' },
];

/** Default handover time shown on the on-duty card until it is edited. */
export const DEFAULT_HANDOVER = '13:00';

/** Album uploads are downscaled to this longest edge before upload. */
export const PHOTO_MAX_EDGE = 2048;
export const PHOTO_JPEG_QUALITY = 0.85;
